<app-draggable-modal-wrapper>
    <h2
        mat-dialog-title
        modal-drag-handle
        class="!text-2xl !font-normal !text-primary-700 !mb-2"
    >
        5-Day Hold
    </h2>
    <hr />
    <mat-dialog-content class="mat-typography">
        <form [formGroup]="form" class="flex flex-col space-y-5">
            <mat-form-field appearance="outline" class="w-full">
                <mat-label>Public Notice Date - Release Date</mat-label>
                <mat-select formControlName="fiveDayHoldDateId" required>
                    @for (
                        fiveDayHoldDate of fiveDayHoldDateOptions;
                        track fiveDayHoldDate.value
                    ) {
                        <mat-option [value]="fiveDayHoldDate.value">{{
                            fiveDayHoldDate.label
                        }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions align="end" class="!p-5">
        <button
            mat-stroked-button
            type="button"
            name="Cancel"
            color="primary"
            class="!border-primary-700"
            (click)="onCancel()"
        >
            Cancel
        </button>
        <button
            mat-raised-button
            type="button"
            name="Submit"
            color="primary"
            (click)="onSave()"
        >
            Submit
        </button>
    </mat-dialog-actions>
</app-draggable-modal-wrapper>
